import React, { useContext } from 'react';
import { Button } from '@curology/ui-components-web/react';

import { trackEvent } from 'utils/metricsTracking';
import { EVENTS } from 'consts/metricsTrackingEvents';
import { navExternalWithQueryString } from 'utils/marketingSafeDomain';

import { type ProductCardProps } from '../ProductCard';
import { ModuleNameContext } from 'components/modules/SqueezeRedesignProducts/components/Subsection/components';
import {
  ButtonPanel,
  ButtonPanelWrapper,
  ButtonSpacer,
} from './EcomProductCTAButton.style';

export const EcomProductCTAButton = ({
  product,
  children,
}: {
  product: ProductCardProps;
  children: React.ReactNode;
}) => {
  const { href, name } = product;
  const moduleName = useContext(ModuleNameContext);

  const handleEcommerceProductClick = (event: React.SyntheticEvent) => {
    event.preventDefault();
    trackEvent(EVENTS.linkClicked, { productName: name, module: moduleName });
    navExternalWithQueryString(href);
  };

  return (
    <ButtonPanelWrapper>
      <ButtonPanel>
        <ButtonSpacer />
        <Button buttonType="secondary" onClick={handleEcommerceProductClick}>
          {children}
        </Button>
      </ButtonPanel>
    </ButtonPanelWrapper>
  );
};
